import SPAIN_CONFIG from './spain';
import FRANCE_CONFIG from './france';
import ITALY_CONFIG from './italy';
import GERMANY_CONFIG from './germany';
import PORTUGAL_CONFIG from './portugal';
import UK_CONFIG from './uk';

export const COUNTRY_NAMES_BY_LOCALE = {
  spain: {
    es: 'espana',
    en: 'spain',
    de: 'spanien',
    fr: 'espagne',
    it: 'spagna',
    pt: 'espanha'
  },
  france: {
    es: 'francia',
    en: 'france',
    de: 'frankreich',
    fr: 'france',
    it: 'francia',
    pt: 'franca'
  },
  italy: {
    es: 'italia',
    en: 'italy',
    de: 'italien',
    fr: 'italie',
    it: 'italia',
    pt: 'italia'
  },
  germany: {
    es: 'alemania',
    en: 'germany',
    de: 'deutschland',
    fr: 'allemagne',
    it: 'germania',
    pt: 'alemanha'
  },
  portugal: {
    es: 'portugal',
    en: 'portugal',
    de: 'portugal',
    fr: 'portugal',
    it: 'portogallo',
    pt: 'portugal'
  },
  uk: {
    es: 'reino-unido',
    en: 'united-kingdom',
    de: 'grossbritannien',
    fr: 'royaume-uni',
    it: 'regno-unito',
    pt: 'reino-unido'
  }
};

export const COUNTRIES_CONFIG = {
  spain: SPAIN_CONFIG,
  france: FRANCE_CONFIG,
  italy: ITALY_CONFIG,
  germany: GERMANY_CONFIG,
  portugal: PORTUGAL_CONFIG,
  uk: UK_CONFIG
};

export const getCountryId = countryName => {
  const country = Object.keys(COUNTRY_NAMES_BY_LOCALE).find(key => {
    const countryNames = Object.values(COUNTRY_NAMES_BY_LOCALE[key]);
    return countryNames.includes(countryName);
  });
  if (!country) {
    return null;
  }
  return country;
};

export const getCountriesConfig = (country, locale) => {
  const countryConfig = COUNTRIES_CONFIG[country] || null;
  if (!countryConfig) {
    return null;
  }

  return {
    ...countryConfig,
    countryName: countryConfig.countryName[locale],
    blog: countryConfig.blog[locale]
  };
};
